/* Free antivirus download */
(function() {
	'use strict';

	var $ = avm.require('cash'),
		$window = $(window),
		waypoints = avm.require('avast.web.waypoints'),
		browser = avastGlobals.detect.browser;


	$window.on('resize scroll', function () {
		if (waypoints($('.free-awards'), null, null, true)) {
			$('.sticky-bar').addClass('is-sticky');
		} else {
			$('.sticky-bar').removeClass('is-sticky');
		}
	});

	if (browser.isChrome || browser.isAvast || browser.isEdgeChromium) {
		$('[data-browser]').css('display', 'none');
		$('[data-browser="chrome"]').css('display', 'block');
	} if (browser.isFirefox || browser.isOpera || browser.isSafari) {
		$('[data-browser]').css('display', 'none');
		$('[data-browser="firefox"]').css('display', 'block');
	}
	if (browser.isEdge || browser.isInternetExplorer) {
		$('[data-browser]').css('display', 'none');
		$('[data-browser="ie"]').css('display', 'block');
	}

})();

// GLOWEB-1656
if(locale == 'ja-jp')  {

	var sliderInfFeatPriSm = tns({
		"container": ".slider-sliderInfFeatPriSm",
		"controlsContainer": ".slider-sliderInfFeatPriSm-controls",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"mouseDrag": true,
		"speed": 400,
		"fixedWidth": 288,
		"gutter": 32,
		"responsive": {
			"576": {
				"center": true
			},
			"768": {
				"items": 2,
				"slideBy": 2,
				"center": false
			},
			"1280": {
				"items": 3,
				"slideBy": 3,
				"controls": true,
				"fixedWidth": 316
			}
		}
	});
}
// /GLOWEB-1656
